import type { LoadableType } from '@confluence/loadable';
import { LoadableLazy } from '@confluence/loadable';
import type { SmartFolderQuickActionMenuItemProps } from './SmartFolderQuickActionMenuItem.ts';

export const LazySmartFolderQuickActionMenuItem: LoadableType<SmartFolderQuickActionMenuItemProps> =
	LoadableLazy({
		loader: async () =>
			(
				await import(
					/* webpackChunkName: "loadable-SmartFolderQuickActionMenuItem" */ '../src/SmartFolderQuickActionMenuItem.tsx'
				)
			).SmartFolderQuickActionMenuItem,
	});

LazySmartFolderQuickActionMenuItem.displayName = 'lazy(SmartFolderQuickActionMenuItem)';
